<template>
  <div style="text-align: center; font-size: 0.85rem;">

    <p v-if="!match">
      /
    </p>

    <p v-if="match && match.result">
      {{ match.result[current.id] }} - {{ match.result[other.id] }}<br />
      <span v-if="match.result.winner == current.id">Won</span>
      <span v-if="match.result.winner != current.id">Lost</span>
    </p>

    <p v-if="match && !match.result">
      <span v-if="match.scheduledTime">{{ match.scheduledTime }}</span>
      <span v-if="!match.scheduledTime">Not scheduled</span>
    </p>

  </div>
</template>

<script>
export default {
  name: 'RoundRobinMatchInfo',
  props: {
    match: [ Object ],
    current: Object,
    other: Object
  },

  methods: {
  }
}
</script>

<style scoped>
</style>
